import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { Button } from './Button';

type PaginationProps = {
  current: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
};

export function Pagination({
  current,
  total,
  pageSize,
  onChange,
}: PaginationProps) {
  const totalPages = total <= pageSize ? 1 : Math.ceil(total / pageSize);
  const isLast = totalPages ? current > totalPages - 1 : true;
  const isFirst = current === 1;

  // handlers
  const handlePreviousClick = () => {
    if (!isFirst) {
      onChange(current - 1);
    }
  };

  const handleNextClick = () => {
    if (!isLast) {
      onChange(current + 1);
    }
  };

  return (
    <div className="mt-2.5 flex items-center">
      <Button
        aria-label="Previous"
        disabled={isFirst}
        variant="outline"
        onClick={handlePreviousClick}
      >
        <CaretLeft className="text-muted-foreground h-4 w-4 shrink-0 transition-transform duration-200" />
      </Button>
      <div className="w-10">
        <span className="text-muted-foreground block text-center">
          {current} / {totalPages}
        </span>
      </div>
      <Button
        aria-label="Next"
        disabled={isLast}
        variant="outline"
        onClick={handleNextClick}
      >
        <CaretRight className="text-muted-foreground h-4 w-4 shrink-0 transition-transform duration-200" />
      </Button>
    </div>
  );
}
